export function calcNewGrade(num1, num2, grade) {
	return (num1 - num2 - grade) * -1;
}